import * as React from 'react';
import { DeleteWorkspaceModalView, DeleteWorkspaceModalViewProps } from './DeleteWorkspaceModal.view';
import { ApolloError } from '@apollo/client';
import { DeleteWorkspaceMutationFn } from '../../../models/graphql';
import { useState } from 'react';
import { useUserData } from '../../../hooks/useUserData';
import { useSelectedOrganization } from '../../../hooks/useSelectedOrganization';
import { showToast } from '../../../helpers/showToast';
import { remapApolloErrors } from '../../../helpers/remapApolloErrors';
import { SubmitHandler } from 'react-hook-form/dist/types/form';
import { FieldValues } from 'react-hook-form';
import { changeSelectedWorkspaceId } from '../../../providers/AppProvider';

export type DeleteWorkspaceModalControllerProps = Omit<
  DeleteWorkspaceModalViewProps,
  'deleteWorkspaceHandler' | 'submitted'
> & {
  deleteWorkspace: DeleteWorkspaceMutationFn;
};

export const DeleteWorkspaceModalController = (props: DeleteWorkspaceModalControllerProps): JSX.Element => {
  const userData = useUserData();
  const [submitted, setSubmitted] = useState<boolean>(false);
  const { selectedOrganization, selectedWorkspace } = useSelectedOrganization();

  const deleteWorkspaceHandler: SubmitHandler<FieldValues> = (data, ev) => {
    ev?.preventDefault();
    setSubmitted(true);

    if (props.workspace) {
      props
        .deleteWorkspace({
          variables: { workspaceId: props.workspace.id },
          update: cache => {
            cache.evict({ id: cache.identify({ id: props.workspace?.id, __typename: 'Workspace' }) });
            cache.gc();
          }
        })
        .then(async () => {
          if (selectedWorkspace && props.workspace?.id === selectedWorkspace.id) {
            selectedOrganization?.workspaces.every(workspace => {
              if (workspace.id !== selectedWorkspace.id) {
                changeSelectedWorkspaceId(workspace.id);
                return false;
              }

              return true;
            });
          }

          await userData.refetch().catch(error => {
            showToast({
              severity: 'error',
              summary: 'Fetching Data Error',
              detail: remapApolloErrors(error as ApolloError)
            });
          });
          props.onClose();
          showToast({
            severity: 'success',
            summary: 'Workspace Deleted',
            detail: 'Workspace has been deleted successfully.'
          });
        })
        .catch(e => {
          showToast({
            summary: 'Delete Workspace',
            detail: remapApolloErrors(e as ApolloError),
            severity: 'error'
          });
          setSubmitted(false);
        });
    }
  };

  const viewProps: DeleteWorkspaceModalViewProps = {
    ...props,
    submitted,
    deleteWorkspaceHandler
  };

  return <DeleteWorkspaceModalView {...viewProps} />;
};
